import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppRootIndexPageComponent } from './app-root-index-page/app-root-index-page.component';
import { appRootNavigationRoutes } from '@/app/egi.pages/app-root.pages/routes';

@NgModule({
  declarations: [AppRootIndexPageComponent],
  imports: [CommonModule],
  providers: []
})
export class AppRootPagesModule {
  constructor() {}

  static readonly routes = appRootNavigationRoutes;
}
